import * as mTypes from '../mutation-types'

const state = {
  contact: {
    list: false,
    taggedList: {
      roleId: null,
      tagId: null,
      orgId: null
    },
    contact: {
      id: {
        formfill: null,
        signup: null,
        donate: null
      }
    }
  },
  form: {
    list: false,
    feedback: {
      id: null
    }
  },
  cf: {
    list: false,
    feedback: {
      id: null
    }
  },
  activity: {
    list: false,
    feedback: {
      id: null
    }
  }
}

const actions = {

}

const mutations = {
  [mTypes.SET_LOADED_OF_CONTACT_LIST] (state, loaded) {
    state.contact.list = loaded
  },
  [mTypes.SET_LOADED_OF_FORM_LIST] (state, loaded) {
    state.form.list = loaded
  },
  [mTypes.SET_LOADED_OF_SIGNUP_LIST] (state, loaded) {
    state.signup.list = loaded
  },
  [mTypes.SET_LOADED_OF_CF_LIST] (state, loaded) {
    state.cf.list = loaded
  },
  [mTypes.SET_LOADED_OF_ACTIVITY_LIST] (state, loaded) {
    state.activity.list = loaded
  },
  [mTypes.SET_LOADED_ID_OF_CONTACT_CONTACT_FORMFILL] (state, id) {
    state.contact.contact.id.formfill = id
  },
  [mTypes.SET_LOADED_ID_OF_CONTACT_CONTACT_SIGNUP] (state, id) {
    state.contact.contact.id.signup = id
  },
  [mTypes.SET_LOADED_ID_OF_CONTACT_CONTACT_DONATE] (state, id) {
    state.contact.contact.id.donate = id
  },
  [mTypes.SET_LOADED_ID_OF_CONTACT_TAGGED_LIST] (state, { roleId, tagId, orgId }) {
    state.contact.taggedList.roleId = roleId
    state.contact.taggedList.tagId = tagId
    state.contact.taggedList.orgId = orgId
  },
  [mTypes.SET_LOADED_ID_OF_FORM_FEEDBACK] (state, id) {
    state.form.feedback.id = id
  },
  [mTypes.SET_LOADED_ID_OF_CF_FEEDBACK] (state, id) {
    state.cf.feedback.id = id
  },
  [mTypes.SET_LOADED_ID_OF_ACTIVITY_FEEDBACK] (state, id) {
    state.activity.feedback.id = id
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loaded.js